import React from 'react';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { validateForm } from '../../services/validate';
import { Post, PostAuthorized } from '../../services/http';

export const BanquestCheck = ({ doValidate, invoiceNumber, reccuringTerm, reccuringMode }) => {
    const openInfoPopup = useStoreActions((actions) => actions.open);
    const config = useStoreState((state) => state.config);
    const showSpinner = useStoreActions((action) => action.showSpinner);
    const hideSpinner = useStoreActions((action) => action.hideSpinner);

    const goToThankYouPage = (returnUrl) => {
        window.location.href = returnUrl;
    };

    const chargeCheck = async () => {
        const validateCardDetails = validateForm(['bqst-routing-number', 'bqst-account-number']);
        showSpinner();
        const validateDonorDetails = await doValidate();
        if (!validateCardDetails.result) {
            hideSpinner();
            openInfoPopup({ notice: validateCardDetails.notice, reload: false, btnName: 'OK' });
            return;
        }
        if (!validateDonorDetails.result) {
            hideSpinner();
            openInfoPopup({ notice: validateDonorDetails.notice, reload: false, btnName: 'OK' });
            return;
        }
        console.log('hit charge check!');
        const result = await Post('/api/donation/ChargeBanquestCheck', {
            routing_number: document.getElementById('bqst-routing-number').value,
            account_number: document.getElementById('bqst-account-number').value,
            invoiceNumber,
            reccuringMode,
            reccuringTerm
        });
        if (result.result) {
            hideSpinner();
            goToThankYouPage(config.frontDomain + 'thank-you/donation/' + invoiceNumber);
        } else {
            hideSpinner();
            openInfoPopup({ notice: result.message, reload: false, btnName: 'OK' });
        }
    };
    return (
        <>
            <div className="fieldset-body" data-animate-delay="02">
                <div className="form-grid">
                    <div className="form-grid__item col-6">
                        <div className="form-field form-insel">
                            <label className="form-legend">Routing Number <span className="star-t">*</span></label>
                            <input placeholder="490000018" onKeyUp={() => validateForm(['bqst-routing-number'])} type="text" id="bqst-routing-number" className="form-insel__input bnqst-number" />
                        </div>
                    </div>
                    <div className="form-grid__item col-6">
                        <div className="form-field form-insel">
                            <label className="form-legend">Account Number<span className="star-t">*</span></label>
                            <input placeholder="490000034" type="text" onKeyUp={() => validateForm(['bqst-account-number'])} id="bqst-account-number" className="form-insel__input cc-expiry-input" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-button _anim-items _fadeUp" data-animate-delay="02">
                <button onClick={chargeCheck} className="form-btn form-btn--block form-btn--info" type="submit">Submit</button>
            </div>
        </>
    );
};
